import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {PostReservationState} from '../../../../../models/postReservationState';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    NgForOf,
    NgClass,
    IconComponent,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

  // toutes les étapes du partenaire
  @Input() public readonly postReservationStatesArray: PostReservationState[] = [];
  // étape à laquelle se trouve l'utilisateur
  @Input() public readonly currentUserStateIndex: number = 0;
  // array des id des steps
  @Input() public readonly postReservationStatesIds: number[] = [];
  // langue de l'utilisateur
  @Input() public locale: string = 'en';
  // étape sur laquelle l'utilisateur a cliqué
  @Output() public wantedState: EventEmitter<any> = new EventEmitter<any>();
  // étape survolée par l'utilisateur
  public hoveredStep: PostReservationState;

  // alt des illustrations utilisées sur la page
  public imgAltText: string = 'Dashboard\'s illustration';

  constructor() {
  }

  public stateTrack(state): number {
    return state.id;
  }

  ngOnInit(): void {
    if (this.locale === 'fr') {
      this.imgAltText = 'Illustration du tableau de bord';
    }
  }



  public goTo(state): void {
    this.wantedState.emit(state);
  }

  public onItemMouseEnter(step: PostReservationState): void {
    this.hoveredStep = step;
  }

  public onItemMouseLeave(): void {
    this.hoveredStep = null;
  }

}
